module.exports = {"511803001":"永兴街道","511803002":"蒙阳街道","511803101":"百丈镇","511803102":"车岭镇","511803104":"马岭镇","511803105":"新店镇","511803106":"蒙顶山镇","511803107":"黑竹镇","511803108":"红星镇","511803109":"中峰镇","511803112":"茅河镇","511803118":"前进镇","511803119":"万古镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511803.json
// module id = 2512
// module chunks = 0